import { render } from "./OptionsDialog.vue?vue&type=template&id=290ae72d"
import script from "./OptionsDialog.vue?vue&type=script&lang=js"
export * from "./OptionsDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anton\\OneDrive\\Escritorios\\09-07-2023\\mailsender\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__